/**
 * Sprachumschalter - funktioniert per Hover am Desktop und per Tipp auf Touch.
 */
document.addEventListener('DOMContentLoaded', function () {
	// Die Seite bringt den Umschalter mehrfach mit, etwa in der Kopf- und in
	// der Fussleiste. Vorher wurde nur der erste eingerichtet - alle weiteren
	// liessen sich auf Touch gar nicht oeffnen, weil dort nur Hover blieb.
	document.querySelectorAll('.lang-nav').forEach(setupLanguageNav)
})

function setupLanguageNav(container) {
	const menu = container.querySelector('.lang-menu')
	const button = container.querySelector('.lang-btn')

	if (!menu || !button) return

	const chevron = button.querySelector('.lang-chevron')

	// 'hidden' entfernen, damit die Uebergaenge greifen; sichtbar wird das
	// Menue erst ueber '!visible'.
	menu.classList.remove('hidden')

	// Auf- und zuklappen an einer Stelle, damit Pfeil, aria-expanded und
	// Sichtbarkeit nicht auseinanderlaufen. Der Pfeil zeigt zu, solange das
	// Menue geschlossen ist, und dreht sich beim Oeffnen nach oben. Beim
	// Schliessen wird die Angabe wieder geleert, damit auf dem Desktop die
	// Drehung per Hover weiter aus dem CSS kommt.
	function setOpen(open) {
		menu.classList.toggle('!visible', open)
		menu.classList.toggle('!opacity-100', open)
		button.setAttribute('aria-expanded', open ? 'true' : 'false')

		if (chevron) {
			chevron.style.transform = open ? 'rotate(180deg)' : ''
		}
	}

	function setMenuPosition() {
		const rect = button.getBoundingClientRect()

		// Fest gegen den Viewport positionieren, unabhaengig von der
		// Bildschirmbreite. Vorher galt unterhalb von 1024px 'absolute' - die
		// Klasse lg:fixed greift erst darueber -, waehrend hier trotzdem mit
		// Viewport-Werten gerechnet wurde. Der Bezugspunkt war damit die nur
		// 32px hohe .lang-nav, und das Menue landete rund 1000px oberhalb des
		// Bildschirms: der Umschalter liess sich auf dem Handy nicht benutzen.
		menu.style.position = 'fixed'
		menu.style.right = window.innerWidth - rect.right + 'px'

		// Nach unten aufklappen, solange darunter Platz ist - in der Kopfleiste
		// ist das immer der Fall. Reicht es nicht, klappt es nach oben auf,
		// damit auch ein Umschalter am Seitenende erreichbar bleibt.
		const platzUnten = window.innerHeight - rect.bottom
		const passtNachUnten = platzUnten >= menu.offsetHeight + 16

		if (passtNachUnten) {
			menu.style.top = rect.bottom + 8 + 'px'
			menu.style.bottom = 'auto'
		} else {
			menu.style.bottom = window.innerHeight - rect.top + 8 + 'px'
			menu.style.top = 'auto'
		}
	}

	setMenuPosition()
	window.addEventListener('resize', setMenuPosition)
	window.addEventListener('scroll', setMenuPosition, { passive: true })

	button.addEventListener('click', function (e) {
		e.preventDefault() // wichtig fuer iPad
		e.stopPropagation()

		if (menu.classList.contains('!visible')) {
			setOpen(false)
			return
		}

		setMenuPosition()
		setOpen(true)
	})

	document.addEventListener('click', function (e) {
		if (!container.contains(e.target)) {
			setOpen(false)
		}
	})

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			setOpen(false)
		}
	})

	// Auf Touch stoert das Hover-Verhalten mehr als es hilft.
	if ('ontouchstart' in window) {
		container.classList.remove('group')
	}
}
